module.exports = __webpack_public_path__ + "static/media/wenggefufu.88b785ed.png";